import { render, staticRenderFns } from "./IconComponentWImage.vue?vue&type=template&id=2f18de2a&"
import script from "./IconComponentWImage.vue?vue&type=script&lang=js&"
export * from "./IconComponentWImage.vue?vue&type=script&lang=js&"
import style0 from "./IconComponentWImage.vue?vue&type=style&index=0&id=2f18de2a&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports